import _ from 'lodash'
import DataType from 'scoreboard/datasets/model/data-type'
const { DATE, TIME, DATE_TIME } = DataType


function isDateTimeDataType(dataType) {
	return _.includes([DATE, TIME, DATE_TIME], dataType)
}

export default isDateTimeDataType

isDateTimeDataType.__filename__ = 'components/is-date-time-data-type.js'
